'use client';

import { c as _c } from "react/compiler-runtime";
import { Chip } from '@common/components';
import { cn } from '@core/utils';
import { useSearchParams } from 'next/navigation';
import { useEffect, useRef, useState, useSyncExternalStore } from 'react';
import { useScrollToSection } from '@/hooks/useScrollToSection';
import type { HOMETOWNS_DETAIL_TAB } from '../constants';
interface HometownsTabProps {
  tabs: {
    title: string;
    tab: HOMETOWNS_DETAIL_TAB;
  }[];
}
export const HometownsTab = t0 => {
  const $ = _c(24);
  const {
    tabs
  } = t0;
  const tabBarRef = useRef(null);
  const scrolledTabRef = useRef(undefined);
  const searchParams = useSearchParams();
  const {
    scrollToSectionWithTab
  } = useScrollToSection();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("tab");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const requestedTab = t1 as HOMETOWNS_DETAIL_TAB | null;
  let t2;
  if ($[2] !== requestedTab || $[3] !== tabs) {
    t2 = tabs.find(t3 => {
      const {
        tab
      } = t3;
      return tab === requestedTab;
    })?.tab;
    $[2] = requestedTab;
    $[3] = tabs;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const availableTab = t2;
  const [firstTab] = tabs;
  const [clickedTab, setClickedTab] = useState(availableTab);
  let t3;
  let t4;
  if ($[5] !== availableTab || $[6] !== scrollToSectionWithTab) {
    t3 = () => {
      if (availableTab) {
        scrollToSectionWithTab(availableTab, {
          behavior: "instant",
          offset: tabBarRef.current?.offsetHeight ?? 0
        });
      }
    };
    t4 = [scrollToSectionWithTab, availableTab];
    $[5] = availableTab;
    $[6] = scrollToSectionWithTab;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== firstTab?.tab || $[10] !== tabs) {
    t5 = onScroll => {
      const readScrolledTab = () => {
        const tabBarBottom = tabBarRef.current?.getBoundingClientRect().bottom;
        const passedTabs = tabs.filter(t6 => {
          const {
            tab: tab_0
          } = t6;
          const section = document.getElementById(tab_0);
          return section ? section.getBoundingClientRect().top <= (tabBarBottom ?? 0) + 1 : false;
        });
        scrolledTabRef.current = passedTabs.at(-1)?.tab ?? firstTab?.tab;
        onScroll();
      };
      window.addEventListener("scroll", readScrolledTab, {
        passive: true
      });
      return () => window.removeEventListener("scroll", readScrolledTab);
    };
    $[9] = firstTab?.tab;
    $[10] = tabs;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const subscribeToScrolledTab = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => scrolledTabRef.current;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== availableTab) {
    t7 = () => availableTab;
    $[13] = availableTab;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const scrolledTab = useSyncExternalStore(subscribeToScrolledTab, t6, t7);
  if (!firstTab) {
    return null;
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("flex gap-4 overflow-x-auto bg-Gray-white py-12 hide-scrollbar", "mobile-tablet:px-20");
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== clickedTab || $[17] !== firstTab || $[18] !== scrollToSectionWithTab || $[19] !== scrolledTab || $[20] !== tabs) {
    t9 = tabs.map(t10 => {
      const {
        title,
        tab: tab_1
      } = t10;
      return <Chip key={tab_1} type="radio" name="hometowns-detail-tab" theme="sub" className="shrink-0" checked={tab_1 === (clickedTab ?? scrolledTab ?? firstTab.tab)} onClick={() => {
        setClickedTab(tab_1);
        scrollToSectionWithTab(tab_1, {
          offset: tabBarRef.current?.offsetHeight ?? 0
        });
        setTimeout(() => {
          setClickedTab(undefined);
        }, 1000);
      }}>{title}</Chip>;
    });
    $[16] = clickedTab;
    $[17] = firstTab;
    $[18] = scrollToSectionWithTab;
    $[19] = scrolledTab;
    $[20] = tabs;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <div ref={tabBarRef} className={t8}>{t9}</div>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};